import { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router"

export default function Home(props) {
    const [redirect, setRedirect] = useState(false)
    const [error, setError] = useState(false)
    const {token} = useParams();
    
    const confirmToken = async () =>{
        const queryResults = await fetch(`${process.env.REACT_APP_API_URL}/confirm/${token}`)
        const queryResultsJSON = await queryResults.json()
        console.log(queryResultsJSON)
        if(queryResultsJSON.result==='success'){
            setRedirect(true)
        }else{
            setError(true)
        }
    }

    useEffect(()=>{
        confirmToken()
    })

    if(redirect){
        return(
            <Redirect to='/home' />
        )
    }else if(error){
        return(
            <div className='confirm-page'>
                There was an error confirming your account
            </div>
        )
    }
    else{
        return(
            <div id='confirm-page'>
                Confirming....
            </div>
        )
    }
}